import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectGlobalOrgRegistrationsListItems } from "../../../../../../redux/global-org-registrations/selector";
import { globalOrgRegistrations } from "../../../../../../redux/global-org-registrations/action";
import { useAppDispatch } from "../../../../../../hooks/hooks";

const DBNPProxyOrgRegistries = (selectedDbnpRegistry : any) => {
    
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const orgRegistryItems = useSelector(selectGlobalOrgRegistrationsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'DBNIEName', headerName: 'DBNIE Name'},
      { field: 'DBNPName', headerName: 'DBNP Name'},
      { field: 'DBNPRegistryName', headerName: 'DBNP Registry Name'},
      { field: 'AccountInfo.AccountName', headerName: 'Account Name', searchField: 'AccountName', sortable: true, filter: true, filterType: 'text' },
      { field: 'OwnedByOUName', headerName: 'OrganizationUnit Name' },
      { field: 'OwnedByOUAccountName', headerName: 'OrganizationUnit AccountName' },
      { field: 'Delivery_preference', headerName: 'Delivery Preference' },
      { field: 'CurrentlyServicing', headerName: 'Currently Servicing', cellRenderer: 'yesNoRenderer' },
      { field: 'IsAcceptOrderByDefaultEnabled', headerName: 'Accept Order By DefaultEnabled', cellRenderer: 'yesNoRenderer' },
      { field: 'IsDirectShipmentEnabled', headerName: 'Direct Shipment Enabled', cellRenderer: 'yesNoRenderer' },
      { field: 'UkId', headerName: 'UkId' },
      { field: 'UseSettingsFromConfigFile', headerName: 'Use Settings From ConfigFile', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const fetchOrgRegistryList = () => {
    dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
        

        "Context": {},
        "Records": [
            {
        "DBNPId":selectedDbnpRegistry?.selectedDbnpRegistry?.DBNPId,
            }
  ],
  "Pagination":{
    "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",
  }
  
      }

    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchOrgRegistryList()
  }, [pageData,pageSize])

  
  const handleEdit = (data: any) => {
    navigate(`org-registries/${data?.Id}`)
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

 
  const handleReloadData = () => {
    fetchOrgRegistryList();
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(globalOrgRegistrations.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations/fetch`,entity:'globalOrgRegistrations',jsonData:{
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (item: any, checked: any) => {
    console.log("Item", checked, item)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    console.log("Items count", checked, items?.length)
    console.log('items', items)
  }

  return (
    <>
      {orgRegistryItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={orgRegistryItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        enableFilter={true} onSearch={handleSearch} onSelect={handleSelect} onSelectAll={handleSelectAll}
          paginationData={orgRegistryItems?.result?.pagination} onEdit={handleEdit}
          additionButtons={additionButtons} headingName="OrgRegistry" />
      }
    </>
  );
};

export default DBNPProxyOrgRegistries;


